/* eslint-disable react/no-multi-comp */
import React,{ useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField'; 
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { useHistory } from "react-router";
import { Alert, AlertTitle } from '@material-ui/lab';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import password_validator from 'password-validator';
import fire from '../firebase';


let schema = new password_validator();
schema
  .is().min(8)
  .is().max(70)
  .has().uppercase()
  .has().lowercase()
  .has().digits()
  .has().not().spaces()

const password_validation_errors = {

  'min': 'Your password should be at least 8 characters long.',
  'uppercase':  'Your password should contain an uppercase letter.',
  'lowercase':  'Your password should contain a lowercase letter.',
  'digits': 'Your password should contain a digit.',
  'same': 'Your passwords should match.'

}

function render_helper_text(errors){
  let response = []
  errors.forEach(function(val,idx)
  {
    response.push(<li>{val}</li>)
  })
  return (
    <ul>{response}</ul>
  )
}

function create_account(history,email,password,firstName,lastName){
  fire.auth().createUserWithEmailAndPassword(email, password).then(resp=>{
    let user_id = resp.user.uid
    // Push the user to users database to keep other details
    fire.database().ref('/users/'+user_id).set({

      first_name:firstName,
      last_name:lastName,
      subscribed:false

    }).then(()=>{
      
      document.getElementById('success').hidden=false

      setTimeout(()=>{
        history.push({
          pathname: '/'
        })
      },3000)

    })
      .catch(err=>{

        console.log(err)

      })
  })
    .catch(err=>{
      alert(err)
    })

}

function check_password_validation(password,confirm_password){
  let errors = schema.validate(password,{list:true})
  if(password!==confirm_password){
    errors.push('same')
  }
  if(errors)
  {
    return errors.map((val,idx)=>{
      return password_validation_errors[val]
    })
  }
  if(!errors)
  {
    return []
  }
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignUp() {
  const history = useHistory();
  const classes = useStyles();
  const [email,setEmail] = useState('')
  const [password,setPassword] = useState('')
  const [confirmPassword,setConfirmPassword] = useState('')
  const [firstName,setFirstName] = useState('')
  const [lastName,setLastName] = useState('')
  const error = check_password_validation(password,confirmPassword)
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        <form className={classes.form} onSubmit={(event)=>{event.preventDefault();create_account(history,email,password,firstName,lastName)}} >
          <Grid container spacing={2}>
            <Grid item xs={12} hidden id="success">
              <Alert severity="success">
                <AlertTitle>Success</AlertTitle>
                  Successfully registered, taking you to the login page.
              </Alert>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="fname"
                name="firstName"
                variant="outlined"
                onChange={(e)=>{setFirstName(e.target.value)}}
                required
                fullWidth
                id="firstName"
                label="First Name"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                onChange={(e)=>{setLastName(e.target.value)}}
                required
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                autoComplete="lname"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                onChange={(e)=>{setEmail(e.target.value)}}
                fullWidth
                id="email"
                type="email"
                label="Email Address"
                name="email"
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                onChange={(e)=>{setPassword(e.target.value)}}
                helperText={error ? render_helper_text(error) : ''}
                error={error.length>0}
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                onChange={(e)=>{setConfirmPassword(e.target.value)}}
                error={error.length>0}
                name="confirm_password"
                label="Confirm Password"
                type="password"
                id="confirm_password"
                autoComplete="current-password"
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={error.length>0}
            className={classes.submit}
          >
            Sign Up
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link href="/sign-in" variant="body2">
                Already have an account? Sign in
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  );
}